import React ,{useEffect}from 'react'
import './Style.css'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Blob from '../Images/Blob.png'
import Blob2 from '../Images/Blob2.png'
import Blob3 from '../Images/Blob3.png'
import Blob4 from '../Images/Blob4.png'

export default function Section5() {
    useEffect(() => {
        AOS.init();
      }, [])
    return (

        //    Section 5 class is "section4" by mistake
        <section className="section4">
            <div className="s4-title-container">    
                <h1 className="s4-title">SCHEDULES FEATURED BY CLASS</h1>
            </div>
            <div className="s4-main-container">
                <div className="s4-content-container" data-aos='fade-right'>
                    <img src={Blob} className="blob" alt=""  />
                    <p className="s4-content-text" id='ninth'>NINTH</p>
                </div>
                <div className="s4-content-container" data-aos='fade-right' data-aos-offset='240'>
                    <img src={Blob2} className="blob" alt=""  />
                    <p className="s4-content-text" id='tenth'>TENTH</p>
                </div>
                <div className="s4-content-container" data-aos='fade-right' data-aos-offset='360'>
                    <img src={Blob3} className="blob" alt=""  />
                    <p className="s4-content-text" id='eleventh' >ELEVENTH</p>
                </div>
                <div className="s4-content-container"data-aos='fade-right' data-aos-offset='480'>
                    <img src={Blob4} className="blob" alt=""  />
                    <p className="s4-content-text" id='twelvth' >TWELVTH</p>
                </div>
            </div>
        </section>
    )
}
